import client from './index';

export interface StockImage {
  id: string;
  url: string;
  name: string;
  category: string;
  tags: string[];
  width: number;
  height: number;
  created_at: string;
}

export interface StockImagesResponse {
  images: StockImage[];
  total: number;
  page: number;
  page_size: number;
}

export interface GenerateItem {
  name: string;
  category?: string;
  tags?: string[];
}

export interface GenerateResponse {
  request_ids: string[];
  submitted: number;
}

export const searchStockImages = async (params?: {
  query?: string;
  category?: string;
  page?: number;
  page_size?: number;
}): Promise<StockImagesResponse> => {
  const { data } = await client.get('/stock-images', { params });
  return data;
};

export const getCategories = async (): Promise<string[]> => {
  const { data } = await client.get('/stock-images/categories');
  return data;
};

export const generateStockImages = async (items: GenerateItem[], prompt?: string): Promise<GenerateResponse> => {
  const body: Record<string, unknown> = { items };
  if (prompt) body.prompt = prompt;
  const { data } = await client.post('/stock-images/generate', body);
  return data;
};

export const deleteStockImage = async (imageId: string): Promise<void> => {
  await client.delete(`/stock-images/${imageId}`);
};

